export default __webpack_public_path__ + "static/media/brightness_lowbrightness_5.be177552.svg";